import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TFacilityTeeSheetSettings } from "redux/reducers/models/facility";

export interface IGetTeeSheetSettings {
  id: number;
}

export interface IPutTeeSheetSettings {
  booking_terms: string;
  cart_waiver_content: string;
  close_date?: string | null;
  default_days_in_advance_start: number;
  default_days_in_advance_end: number;
  default_open_time: string; // time string
  default_open_structure: string;
  display_booking_graph: boolean;
  display_customer_type: boolean;
  display_online_pricing: boolean;
  enable_web_booking: boolean;
  enable_cart_bookings: boolean;
  foursome_bookings: string;
  max_booking_size?: number;
  open_date?: string | null;
  orders_void_with_note?: boolean;
  payment_terms: string;
  power_cart_maintenance_time: number;
  power_cart_nine_hole_time: number;
  power_cart_eighteen_hole_time: number;
  default_carts_available: number;
  single_bookings: string;
  tee_sheet_limited?: boolean;
  tee_sheet_new?: boolean;
  track_cart_numbers: boolean;
  use_cart_inventory: boolean;
  display_turn_division_code: boolean;
  threesome_bookings: string;
  twosome_bookings: string;
  web_cancellation_hours: number;
  web_edit_hours: number;
  validate_power_cart_count: boolean;
  gift_cards_default_auto_generate_code: boolean;
  web_tee_times_display: "list" | "tee_sheet" | null;
}

export interface IPutPrinterSettings {
  print_server_ip: null | string;
  print_server_port: null | number;
}

export async function GetFacilityTeeSheetSettings(
  params?: IGetTeeSheetSettings,
  useGlobalLoader?: boolean,
  token?: CancelToken,
) {
  return await APIGet<TFacilityTeeSheetSettings>(
    APIUrl(AdminType.FacilityAdmin, "/facility/settings/tee-sheet"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PutFacilityTeeSheetSettings(params: IPutTeeSheetSettings, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/settings/tee-sheet"), params, useGlobalLoader);
}

export async function PutFacilityPrinterSettings(params: IPutPrinterSettings, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/settings/print"), params, useGlobalLoader);
}

export async function GetFacilityPrinterSettings(useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/settings/print"), undefined, useGlobalLoader, token);
}
